export const services = [
  {
    id: 1,
    title: "Marka Konumlandırması",
    description:
      "Seni rakiplerinden ayıracak o keskin pozisyonu buluyoruz. Benzersiz değer teklifinle pazara girerken herkes dönüp bakacak.",
    icon: "ri-compasses-line",
  },
  {
    id: 2,
    title: "Dijital Pazarlama ve Reklam",
    description:
      "Google ve Meta'da paranı çöpe atma. Veriyle beslenen, sürekli optimize edilen, kreatif ve agresif kampanyalarla yatırımını katlayarak geri al.",
    icon: "ri-megaphone-line",
  },
  {
    id: 3,
    title: "Web Sitesi ve Yazılım",
    description:
      "Hızlı, güvenli, kullanıcıyı içine çeken web siteleri. Teknik altyapı sağlam, tasarım şık. Sektöründe fark yaratacak dijital ürünler inşa ediyoruz.",
    icon: "ri-code-s-slash-line",
  },
  {
    id: 4,
    title: "E-Ticaret ve E-İhracat",
    description:
      "Trendyol, Hepsiburada, Amazon, Shopify... Hepsi bizim oyun alanımız. Yurt dışına açılmanın en hızlı yolunu biliyoruz. Satışlarını global ölçeğe taşı.",
    icon: "ri-shopping-bag-3-line",
  },
  {
    id: 5,
    title: "B2B Lead Generation",
    description:
      "LinkedIn ve e-posta otomasyonlarıyla potansiyel müşterilerini tek tek avlıyoruz. Satış ekibin kapı çalmaktan değil, teklif vermekten yorulacak.",
    icon: "ri-user-search-line",
  },
  {
    id: 6,
    title: "İçerik Üretimi ve Sosyal Medya",
    description:
      "Sıradan postlar değil, durduran içerikler. Profesyonel video prodüksiyonu, cesur kreatifler ve doğru influencer iş birlikleriyle markanı konuşturuyoruz.",
    icon: "ri-movie-line",
  },
];